import { AccessController } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useCreateAccessControllerQuery = () => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/access-controllers`
	return useLazyQuery<AccessController, void>(url, "POST")
}
